module.exports = __webpack_public_path__ + "img/tree-08-b-leaves.ed2abd0b.png";